import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { FaCode, FaCodeBranch, FaInfoCircle } from 'react-icons/fa';
import { useOutletContext } from 'react-router-dom';
import packageJson from '../../../../package.json';
import LanguageSelector from '../../../lib/i18n/LanguageSelector';
import auth_bg from '../../../assets/images/auth_bg_dev.png';
import { GlobalOperations } from 'config/GlobalApiOperations';

// type LayoutContextType = { setPageTitle: (title: string) => void };

const DeveloperScreen: React.FC = () => {

  // const { setPageTitle } = useOutletContext<LayoutContextType>();
  const pageTitle = "Albinasoft A.Ş.";
  const isProd = GlobalOperations.isProd;
  const version = packageJson.version;
  const name = packageJson.name;

  // useEffect(() => {
  //   setPageTitle(pageTitle);
  // }, [setPageTitle]);

  return (
    <div>
      <Helmet>
        <title>Developer Screen</title>
      </Helmet>
      <div className="content-inner container-fluid pb-0">
        {/* <div className="row justify-content-center d-flex align-items-stretch">
          <div className="col-xl-6 col-md-9 col-12">
            <div className="row">
              <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex  align-items-center gap-3">
                      <div className="bg-primary-subtle p-2 rounded">
                        <FaCodeBranch size={30} className="text-primary" />
                      </div>
                      <div>
                        <h4>v{version}</h4>
                        <span className="text-dark">Application Version</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex  align-items-center gap-3">
                      <div className="bg-primary-subtle p-2 rounded">
                        <FaCode size={30} className="text-primary" />
                      </div>
                      <div>
                        <h4>{isProd ? 'Production' : 'Development'}</h4>
                        <span className="text-dark">Application Type</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex  align-items-center gap-3">
                      <div className="bg-primary-subtle p-2 rounded">
                        <FaInfoCircle size={30} className="text-primary" />
                      </div>
                      <div>
                        <h4>...</h4>
                        <span className="text-dark">...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex  align-items-center gap-3">
                      <div className="bg-primary-subtle p-2 rounded">
                        <FaInfoCircle size={30} className="text-primary" />
                      </div>
                      <div>
                        <h4>...</h4>
                        <span className="text-dark">...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex  align-items-center gap-3">
                      <div className="bg-primary-subtle p-2 rounded">
                        <FaInfoCircle size={30} className="text-primary" />
                      </div>
                      <div>
                        <h4>...</h4>
                        <span className="text-dark">...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex  align-items-center gap-3">
                      <div className="bg-primary-subtle p-2 rounded">
                        <FaInfoCircle size={30} className="text-primary" />
                      </div>
                      <div>
                        <h4>...</h4>
                        <span className="text-dark">...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="row align-items-center vh-100">

                <div className="col-lg-12 d-flex justify-content-center align-items-center">
                    <div className="w-66">
                        <div className="navbar-brand d-flex align-items-center mt-3 mb-3 justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div className="logo-main">
                                        <div className="logo-normal">
                                            <svg className="icon-30 text-primary" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 108 108">
                                                <g transform="translate(0,108) scale(0.1,-0.1)" fill="currentColor" stroke="none">
                                                    <path d="M397 1045 c-138 -38 -272 -146 -332 -269 -69 -139 -80 -287 -31 -421 l21 -60 290 4 c426 5 429 7 124 64 -140 27 -258 52 -262 56 -17 17 -26 136 -16 211 24 171 124 315 275 398 l59 31 -40 0 c-22 -1 -62 -7 -88 -14z" />
                                                    <path d="M547 1038 c-8 -13 -72 -131 -142 -263 -70 -132 -139 -260 -152 -285 -30 -54 -47 -72 180 193 117 137 167 187 182 187 44 0 167 -72 229 -134 105 -105 156 -229 156 -381 l1 -80 19 35 c33 61 53 174 47 260 -17 223 -169 410 -386 474 -78 23 -117 21 -134 -6z" />
                                                    <path d="M624 805 c4 -11 46 -128 92 -259 l84 -240 -31 -32 c-61 -63 -191 -118 -306 -129 -111 -11 -247 26 -352 96 l-34 23 13 -25 c30 -54 135 -146 210 -181 167 -80 329 -77 491 8 65 34 189 149 189 175 0 10 -336 557 -353 574 -7 7 -7 3 -3 -10z" />
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                    <h5 className="logo-title ms-1 mb-0" data-setting="app_name">Albinasoft A.Ş.</h5>
                                </div>
                            {/* <div className="d-flex">
                                <ThemeToggle />
                            </div> */}
                        </div>

                        <h2 className="mb-2 text-center">Developer Screen</h2>
                        <p className="text-center">{name}</p>

                        <div className="row">
                            <div className="col-md-6 col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex  align-items-center gap-3">
                                            <div className="bg-primary-subtle p-2 rounded">
                                                <FaCodeBranch size={30} className="text-primary" />
                                            </div>
                                            <div>
                                                <h4>v{version}</h4>
                                                <span className="text-dark">Application Version</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex  align-items-center gap-3">
                                            <div className="bg-primary-subtle p-2 rounded">
                                                <FaCode size={30} className="text-primary" />
                                            </div>
                                            <div>
                                                <h4>{isProd ? 'Production' : 'Development'}</h4>
                                                <span className="text-dark">Application Type</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex  align-items-center gap-3">
                                            <div className="bg-primary-subtle p-2 rounded">
                                                <FaInfoCircle size={30} className="text-primary" />
                                            </div>
                                            <div>
                                                <h4>...</h4>
                                                <span className="text-dark">...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex  align-items-center gap-3">
                                            <div className="bg-primary-subtle p-2 rounded">
                                                <FaInfoCircle size={30} className="text-primary" />
                                            </div>
                                            <div>
                                                <h4>...</h4>
                                                <span className="text-dark">...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex  align-items-center gap-3">
                                            <div className="bg-primary-subtle p-2 rounded">
                                                <FaInfoCircle size={30} className="text-primary" />
                                            </div>
                                            <div>
                                                <h4>...</h4>
                                                <span className="text-dark">...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex  align-items-center gap-3">
                                            <div className="bg-primary-subtle p-2 rounded">
                                                <FaInfoCircle size={30} className="text-primary" />
                                            </div>
                                            <div>
                                                <h4>...</h4>
                                                <span className="text-dark">...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </div>
    </div>

  );
};

export default DeveloperScreen;
